import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GTMService } from '@services';
import {
  BookingStore,
  DashboardTileType,
  dashboardTileTypeToDashboardTileObjectMapper,
  InstallationDetailsStore,
  KanbanBoardStore,
} from '@store';
import { of } from 'rxjs';
import { DashboardInstallationUrls } from '../../+installations/installations-routing.helper';
import { environment } from '../../../environments/environment';
import { TileNavigationActionItem } from './dashboard.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardNavigationHelperService {
  protected readonly deviceMonitoringLink = `/${DashboardInstallationUrls.List}/${DashboardInstallationUrls.Board}`;

  constructor(
    private bookingStore: BookingStore,
    private installationDetailsStore: InstallationDetailsStore,
    private kanbanBoardStore: KanbanBoardStore,
    private translateService: TranslateService,
    private gtmService: GTMService,
    private router: Router
  ) {}

  public getNavigationActionItem(tileType: DashboardTileType): TileNavigationActionItem {
    switch (tileType) {
      case DashboardTileType.ContractsEndingSoon:
        return {
          label: this.translateService.instant(
            '+DASHBOARD.DASHBOARD_TILES.NAVIGATION.GO_TO_BOOKING_OVERVIEW'
          ),
          tileType: tileType,
          gtmEvent: {
            label: 'onGoToPage',
            action: 'Open booking overview',
            category: 'Dashboard',
          },
          visible$: this.bookingStore.hasAccessToBooking$,
          navigateTo: '/booking-overview',
        };
      case DashboardTileType.DevicesWithLowWifi:
        return {
          label: this.translateService.instant(
            '+DASHBOARD.DASHBOARD_TILES.NAVIGATION.PLACE_AN_ORDER'
          ),
          tileType: tileType,
          gtmEvent: {
            label: 'onGoToShop',
            action: 'Buy repeater',
            category: 'Dashboard',
          },
          visible$: this.installationDetailsStore.isPartnerShopLinkAvailable$,
          navigateTo: environment.buyRepeaterLink,
        };
      default:
        return {
          label: this.translateService.instant(
            '+DASHBOARD.DASHBOARD_TILES.NAVIGATION.GO_TO_DEVICE_MONITORING'
          ),
          tileType: tileType,
          gtmEvent: {
            label: 'onGoToPage',
            action: 'Open installation details',
            category: 'Dashboard',
          },
          visible$: of(true),
          navigateTo: this.deviceMonitoringLink,
          kanbanBoardFilters:
            dashboardTileTypeToDashboardTileObjectMapper[tileType].kanbanBoardFilter ?? null,
        };
    }
  }

  public navigate(tileNavigationButton: TileNavigationActionItem): void {
    if (tileNavigationButton.kanbanBoardFilters) {
      this.kanbanBoardStore.predefineDashboardFilters(tileNavigationButton.kanbanBoardFilters);
    }
    this.gtmService.track(
      tileNavigationButton.gtmEvent.label,
      tileNavigationButton.gtmEvent.action,
      tileNavigationButton.gtmEvent.category
    );
    if (tileNavigationButton.tileType === DashboardTileType.DevicesWithLowWifi) {
      this.router.navigate([]).then(() => window.open(tileNavigationButton.navigateTo, '_blank'));
    } else {
      this.router.navigate([tileNavigationButton.navigateTo]);
    }
  }
}
